export const NONE = 'none';
export const BOTH = 'both';
export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';

export const all = [NONE, HORIZONTAL, VERTICAL, BOTH];

export type ScrollDirection = 'none' | 'both' | 'horizontal' | 'vertical';
